import { render, staticRenderFns } from "./ExchangeRateDateRule.yaml?vue&type=template&id=16145fac&component"
import script from "./ExchangeRateDateRule.yaml?vue&type=script&lang=ts&component"
export * from "./ExchangeRateDateRule.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports